(function() {
  'use strict';

  angular.module('blocks.image', []);
})();
